import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { TimeBasedSettingForSpecificCallerDto } from '../../../dto/timebasedsetting/timebasedsettingforspecificcallerdto';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { TimeBasedSettingForSpecificCallerRequest } from './timebasedsettingforspecificcallerrequest';
import { WeekDaysToNumberConverter } from '../../../dto/timebasedsetting/weekdaystonumberconverter';
import * as moment from 'moment';
import { Strings } from '../../../../utils/resources/strings';
import { DateTransform } from '../../../../ui/toolkit/datetransform/datetransform';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class TimeBasedSettingForSpecificCallerAPI extends SixdeeCRBTAPI<TimeBasedSettingForSpecificCallerRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod()
    {
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/dedicated-user-tone-addition-with-time-setting
        return "dedicated-user-tone-addition-with-time-setting";
    }

    getRequestData()
    {
        let timeBasedSettingForSpecificCallerRequestDto : TimeBasedSettingForSpecificCallerDto;
        timeBasedSettingForSpecificCallerRequestDto = this.getRequest().getTimeBasedSettingForSpecificCallerRequest();

        let commonRequestParameters : string = "clientTxnId=21072020"+"&"+
        "aPartyMsisdn=" + timeBasedSettingForSpecificCallerRequestDto.getAPartyMsisdn()+"&"+
        "toneId="+ timeBasedSettingForSpecificCallerRequestDto.getToneId()+"&"+
        
        "language="+ (timeBasedSettingForSpecificCallerRequestDto.getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
        "priority="+ timeBasedSettingForSpecificCallerRequestDto.getPriority()+"&"+
        "channelId="+ timeBasedSettingForSpecificCallerRequestDto.getChannelId()+"&"+
        "bPartyMsisdn=" + timeBasedSettingForSpecificCallerRequestDto.getBPartyMsisdn()+"&"+
        "serviceId=" + timeBasedSettingForSpecificCallerRequestDto.getServiceId()+"&"+
        "activityId="+ timeBasedSettingForSpecificCallerRequestDto.getActivityId()+"&"+
        "packName="+ timeBasedSettingForSpecificCallerRequestDto.getPackName();
        console.log("--tiger"+timeBasedSettingForSpecificCallerRequestDto.getLanguage() );
        let timeSettingSelected = timeBasedSettingForSpecificCallerRequestDto.getTimeSettingSelected();
        
        if(timeSettingSelected === this.getContext().getResources().getString(Strings.full_day))
        {
            return commonRequestParameters+"&"+
            "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
            "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForSpecificCallerRequestDto.getWeeklyDays())+"&"+
            "weeklyStartTime="+ this.getContext().getResources().getString(Strings.default_start_time)+"&"+
            "weeklyEndTime="+ this.getContext().getResources().getString(Strings.default_end_time);
        }
        else if(timeSettingSelected === this.getContext().getResources().getString(Strings.select_time))
        {
            return commonRequestParameters+"&"+
            "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
            "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForSpecificCallerRequestDto.getWeeklyDays())+"&"+
            "weeklyStartTime="+ timeBasedSettingForSpecificCallerRequestDto.getStartTimestamp() +"&"+
            "weeklyEndTime="+ timeBasedSettingForSpecificCallerRequestDto.getEndTimestamp();
        }
        else
        {
            let repeatInterval = timeBasedSettingForSpecificCallerRequestDto.getRepeatInterval();
            let startDate = timeBasedSettingForSpecificCallerRequestDto.getStartTimestamp().split(" ");
            let endDate = timeBasedSettingForSpecificCallerRequestDto.getEndTimestamp().split(" ");
                
            if(repeatInterval === this.getContext().getResources().getString(Strings.none))
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.CUSTOM_TIME) +"&"+
                   //"customizeStartDate="+ moment(startDate[0], "DD/MM/yyyy").format("yyyy-MM-DD") +"&"+
                   "customizeStartDate="+ DateTransform.formatDateForBackend(startDate[0]) +"&"+
                   //"customizeEndDate="+ moment(endDate[0], "DD/MM/yyyy").format("yyyy-MM-DD") +"&"+
                   "customizeEndDate="+ DateTransform.formatDateForBackend(endDate[0]) +"&"+
                   "customizeStartTime="+ startDate[1] +"&"+
                   "customizeEndTime="+ endDate[1];
            }
            else if(repeatInterval === this.getContext().getResources().getString(Strings.monthly))
            {
                let startDateformat = moment(startDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
                let endDateformat = moment(endDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
    
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.MONTHLY_TIME) +"&"+
                   /* "startDayMonthly="+ String(moment(startDateformat).date()) +"&"+
                   "endDayMonthly="+ String(moment(endDateformat).date()) +"&"+ */
                   "startDayMonthly="+ String(moment(startDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "endDayMonthly="+ String(moment(endDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "monthlyStartTime="+ startDate[1] +"&"+
                   "monthlyEndTime="+ endDate[1];

            }
            else if(repeatInterval === this.getContext().getResources().getString(Strings.yearly))
            {
                let startDateformat = moment(startDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
                let endDateformat = moment(endDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");

                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.YEARLY_TIME) +"&"+
                 /*   "yearlyStartMonth="+ String(moment(startDateformat).month() + 1) +"&"+
                   "yearlyEndMonth="+ String(moment(endDateformat).month() + 1) +"&"+
                   "yearlyStartDay="+ String(moment(startDateformat).date()) +"&"+
                   "yearlyEndDay="+ String(moment(endDateformat).date()) +"&"+ */
                   "yearlyStartMonth="+ String(moment(startDateformat, 'MM/DD/YYYY').format('MM')) +"&"+
                   "yearlyEndMonth="+ String(moment(endDateformat, 'MM/DD/YYYY').format('MM')) +"&"+
                   "yearlyStartDay="+ String(moment(startDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "yearlyEndDay="+ String(moment(endDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "yearlyStartTime="+ startDate[1] +"&"+
                   "yearlyEndTime="+ endDate[1];
            }
            else
            {
                return "";
            }
        }


       
        /* // ALL CALLER - Full Day/Specific Time - Selected days of the week
        if(timeBasedSettingForSpecificCallerRequestDto.getWeeklyStartTime() !== undefined &&
        timeBasedSettingForSpecificCallerRequestDto.getWeeklyEndTime() !== undefined)
        {
            return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
                   "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForSpecificCallerRequestDto.getWeeklyDays())+"&"+
                   "weeklyStartTime="+ timeBasedSettingForSpecificCallerRequestDto.getWeeklyStartTime()+"&"+
                   "weeklyEndTime="+ timeBasedSettingForSpecificCallerRequestDto.getWeeklyEndTime();
        }
        else // ALL CALLER - Specific Date & Time
        {
            // ALL CALLER - Specific Date & Time - Monthly repeat
            if(timeBasedSettingForSpecificCallerRequestDto.getStartDayMonthly() !== undefined &&
            timeBasedSettingForSpecificCallerRequestDto.getEndDayMonthly() !== undefined)
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.MONTHLY_TIME) +"&"+
                   "startDayMonthly="+ timeBasedSettingForSpecificCallerRequestDto.getStartDayMonthly()+"&"+
                   "endDayMonthly="+ timeBasedSettingForSpecificCallerRequestDto.getEndDayMonthly()+"&"+
                   "monthlyStartTime="+ timeBasedSettingForSpecificCallerRequestDto.getMonthlyStartTime()+"&"+
                   "monthlyEndTime="+ timeBasedSettingForSpecificCallerRequestDto.getMonthlyEndTime();
            } // ALL CALLER - Specific Date & Time - Yearly repeat
            else if(timeBasedSettingForSpecificCallerRequestDto.getYearlyStartMonth() !== undefined &&
                    timeBasedSettingForSpecificCallerRequestDto.getYearlyEndMonth() !== undefined)
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.YEARLY_TIME) +"&"+
                   "yearlyStartMonth="+ timeBasedSettingForSpecificCallerRequestDto.getYearlyStartMonth()+"&"+
                   "yearlyEndMonth="+ timeBasedSettingForSpecificCallerRequestDto.getYearlyEndMonth()+"&"+
                   "yearlyStartDay="+ timeBasedSettingForSpecificCallerRequestDto.getYearlyStartDay()+"&"+
                   "yearlyEndDay="+ timeBasedSettingForSpecificCallerRequestDto.getYearlyEndDay()+"&"+
                   "yearlyStartTime="+ timeBasedSettingForSpecificCallerRequestDto.getYearlyStartTime()+"&"+
                   "yearlyEndTime="+ timeBasedSettingForSpecificCallerRequestDto.getYearlyEndTime();
            }
            else // ALL CALLER - Specific Date & Time - NO repeat
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.CUSTOM_TIME) +"&"+
                   "customizeStartDate="+ timeBasedSettingForSpecificCallerRequestDto.getCustomizeStartDate()+"&"+
                   "customizeEndDate="+ timeBasedSettingForSpecificCallerRequestDto.getCustomizeEndDate()+"&"+
                   "customizeStartTime="+ timeBasedSettingForSpecificCallerRequestDto.getCustomizeStartTime()+"&"+
                   "customizeEndTime="+ timeBasedSettingForSpecificCallerRequestDto.getCustomizeEndTime();
            }
        } */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerapi.tsx